import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {closest} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tabs from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tabs(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    if (element.getAttribute('data-content-url')) {
        new Popover(element, {
            trigger: 'focus',
            container: closest('.modal', element) ? closest('.modal', element) : 'body',
            html: true,
            content: '<div class="js-dynamic-modal__content"><div class="loading-overlay loading-overlay--content loading-overlay--content-sm js-dynamic-modal__loading" hidden><div><div class="loading-spinner"><div class="loading-spinner__item loading-spinner__item--1"></div><div class="loading-spinner__item loading-spinner__item--2"></div><div class="loading-spinner__item loading-spinner__item--3"></div></div></div></div></div>',
            template: '<div class="popover js-dynamic-popover" role="tooltip">' +
                '<div class="popover-arrow"></div>' +
                '<h3 class="popover-header"></h3>' +
                '<div class="popover-body">' +
                '</div></div>'
        });
    } else {
        new Popover(element, {
            html: true,
            trigger: 'focus'
        });
    }
});

import * as productNumberSpinner from './scripts/product-number-spinner'
productNumberSpinner.init();

import * as products from './scripts/product-item'
products.init();

import * as dynamicModal from './scripts/dynamic-modal'
dynamicModal.init();

import * as dynamicTabs from './scripts/dynamic-tabs'
dynamicTabs.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();